import moment from "moment";

class FormatService {

    private static serviceInstance: FormatService;

    private constructor() { }

    public static get instance() {
        return this.serviceInstance || (this.serviceInstance = new this());
    }

    public formatDeviceSize(value: string): string {
        switch (value) {
            case "1.0-767.0":
                return "Mobile";
            case "768.0-991.0":
                return "Tablet";
            case "992.0-*":
                return "Desktop";
            default:
                return value;
        }
    }

    public formatNumberPercentage(value: number, value1: number, value2: number): string {
        return `${this.formatNumber(value)} (${this.getPercentage(value1, value2)})`;
    }

    public formatNumber(value: number): string {
        return value.toLocaleString();
    }

    public formatCurrency(value: number): string {
        return value.toLocaleString("en-GB", { style: "currency", currency: "GBP" });
    }

    public getPercentage(value1: number, value2: number): string {
        if (value1 === 0 || value2 === 0) {
            return "0.00%";
        }

        return `${((value1 / value2) * 100).toFixed(2)}%`;
    }

    public formatDate(initialDate: Date): string {
        return moment(initialDate).toISOString();
    }

    public getDateDiff(initialDate: Date | null): number {
        if (initialDate) {
            const startDate = moment(initialDate);
            const now = moment();
            return now.diff(startDate, "days") + 1;
        }

        return 0;
    }

    public calculatePeriod(start: Date | null, end: Date | null): number {
        if (start && end) {
            const startDate = moment(start);
            const endDate = moment(end);
            return endDate.diff(startDate, "days");
        }

        return 0;
    }

    public commaSeparatedList(value: string[]): string {
        const result = Array.from(new Set(value));
        return result.join(", ");
    }

    public camelCaseToSentenceCase(value: string): string {
        const result = value.replace(/([A-Z]+)/g, " $1");
        return result;
    }
}

export const formatService = FormatService.instance;
